export default __webpack_public_path__ + "static/media/23A.e166f742.JPG";